import styles from './ClientOrderList.module.css'
import ModalWindow from "../../FormTemplate/ModalWindow/ModalWindow";
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
import React, {useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import {AddFeedBackInt} from "./ClientOrderList";
interface ClientOrderAppealPropsInt
{
    orderId:string
    author: string
    onClose:()=>void
}
export default function ClientOrderAppeal({orderId,onClose,author}:ClientOrderAppealPropsInt){
    const [appeal, setAppeal] = useState("")
    const appealErrorLine = useRef<ErrorLineItemRef>(null)

    const addFeedBackData = useRef<AddFeedBackInt>()
    const [ldrAddFeedback,rsAddFeedback,exAddFeedback] = useApiQuery("/appeal/add","post",addFeedBackData);


    const handleSendAppeal = () =>{
        if(appeal?.length < 5 || !appeal)
        {
            if(appealErrorLine.current)appealErrorLine.current.show("Не корретная длина вопроса", true,2000)
            return
        }

        addFeedBackData.current = {
            type: 2,
            author: author,
            parent: 0,
            xData: orderId,
            text: appeal,
            capt:""
        }
        exAddFeedback().then((e)=>{
            if(e?.success)
            {
                if(appealErrorLine.current)appealErrorLine.current.show("Обращение отправлено", false,2000)
                setTimeout(()=>onClose(),2000)
                return
            }
            if(appealErrorLine.current)appealErrorLine.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,2000)
        }).catch((e)=>{
            if(appealErrorLine.current)appealErrorLine.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,2000)
        })


    }

    return(
        <ModalWindow onClose={() => onClose()}>
            <MainFormTemplate title={`Обращение по заказу [ ${orderId} ]`} maxWidth={"500px"} background={"white"}>
                <div className={"row mt-3"}>
                    <div className={"col-lg-12"}>
                        <InputItem
                            val={appeal}
                            mode={"ei"}
                            info={"Текст обращения"}
                            title={""}
                            titleShift={-6}
                            inputType={2}
                            lineCount={5}
                            placeHolder={"Текст обращения"}
                            onChange={(e)=>setAppeal(e)}
                        ></InputItem>
                    </div>

                </div>

                <div className={styles.errCont}>
                    <ErrorLineItem ref={appealErrorLine}></ErrorLineItem>
                </div>

                <div className={"row"}>
                    <div className={styles.actCont} >

                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    onClick={(e)=>handleSendAppeal()}
                            >Отправить</button>
                        </div>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    onClick={(e)=>onClose()}
                            >Закрыть</button>
                        </div>

                        <div className={styles.ldrCont} >
                            <WaitLoader loading={ldrAddFeedback} api={rsAddFeedback} onlyLoading={true}>

                            </WaitLoader>
                        </div>

                    </div>


                </div>

            </MainFormTemplate>

        </ModalWindow>
    )
}